export const DEFAULT_CURRENCY = 'EUR';
export const CURRENCY_UNIT = 'CURRENCY';
